import { FeatureName } from "@faire/web-api--source/indigofair/data/FeatureName";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { route as cartRoute } from "@faire/web-api--source/routes/www/cart";
import { route as checkoutRoute } from "@faire/web-api--source/routes/www/checkout";
import { route as nowOnFaireRoute } from "@faire/web-api--source/routes/www/my-brands/now-on-faire";
import { route as ordersRoute } from "@faire/web-api--source/routes/www/orders";
import { route as invoiceRoute } from "@faire/web-api--source/routes/www/user/account/invoices";

import { ModalTypeOrFeature } from "./type";

export const featureToPromoModalType = (
  modalTypeOrFeature: ModalTypeOrFeature | undefined
): PromoModalType | undefined => {
  if (!modalTypeOrFeature) {
    return undefined;
  }

  if (isFromConductor(modalTypeOrFeature)) {
    return PromoModalType.CONDUCTOR_MODAL;
  }

  return modalTypeOrFeature as PromoModalType;
};

const isFromConductor = (
  modalTypeOrFeature: ModalTypeOrFeature | undefined
): boolean => {
  return Object.values(FeatureName).includes(modalTypeOrFeature as FeatureName);
};

export const BRAND_CONSOLIDATION_BLOCKED_PATHS = [
  cartRoute,
  checkoutRoute,
  ordersRoute,
  invoiceRoute,
  nowOnFaireRoute,
];
